<template>
  <transition name="modal">
    <section class="popup-packages">
      <div class="popup-packages--content">
        <div class="popup-heading">
          <a
            aria-role="button"
            aria-label="close"
            href="#footer"
            class="popup-packages__close"
            @click="$emit('close')"
          >&times;</a>

          <br />
        </div>
        <div class="package__content">
          <h4 class="heading-tertiary">Packages</h4>
          <div class="package__content--image u-margin-bottom-medium"></div>
          <div class="package__content--text u-margin-bottom-large">
            <div class="heading-secondary-still">Newborn Package - $215</div>
            <p
              class="paragraph package__paragraph u-margin-bottom-small"
            >Congratulations on your precious miracle! The newborn package is typically photographed between 5-10 days old.</p>
            <p class="paragraph package__paragraph u-margin-bottom-medium">
               It includes:
            <ul class="u-margin-left-medium">
              <li>a pre-consultation</li>
              <li>a 2-3 hour in-studio session</li>
              <li>an in-person reveal</li>
              <li>a flashdrive containing 24-30 fine portraits and a onedrive link to those same images</li>
            </ul>
            </p>
            <div class="heading-secondary-still">Milestone Package - $415</div>
            <p
              class="paragraph package__paragraph u-margin-bottom-small"
            >Way to plan ahead! The milestone package captures how quickly your child develops over the first year. At 6 months old, your little one can often smile, grab toes, hold her chest and head off the floor when on her tummy, and balance in a sitting position. By 1 year, your child can often crawl, stand while holding onto something, or even walk! Clearly all babies grow and develop at their own pace. The focus in the above examples is that there is always something fun and new to document in the milestone sessions!</p>
            <p
              class="paragraph package__paragraph u-margin-bottom-medium"
            >It includes:
            <ul class="u-margin-left-medium">
              <li>the entire Newborn Package</li>
              <li>6 month old pre-consultation</li>
              <li>30min-45min session</li>
              <li>a reveal of 8-10 images on a flashdrive and a onedrive link</li>
              <li>a 1 year pre-consultation</li>
              <li>45min-1hr session</li>
              <li>a reveal of 8-10 images on a flashdrive and a onedrive link</li>
            </ul>
            </p>
            <div class="heading-secondary-still">ADD ON PACKAGE - $200</div>
            <p class="paragraph package__paragraph u-margin-bottom-small">
              <i>*must have previously purchased either the Newborn Package or the Milestone Package</i>
              <br />You've got it all covered! You already have cherished portraits of the beginning of your child's life! This package allows you to continue the story clear through school age with annual sessions for 2 to 5 years old! Time seems to fly by and it's easy to miss scheduling time for things like annual photos. By ordering this package, your work is done! I will contact you each year when it's time for new photos. I get so excited to see your once-tiny baby thrive and to see their personality develop over time.
            </p>
            <p
              class="paragraph package__paragraph u-margin-bottom-medium"
            >It includes:
            <ul class="u-margin-left-medium">
              <li>4 pre-consultations (one for each year)</li>
              <li>4 mini sessions (15-30 minutes each)</li>
              <li>4 reveals of 5 images on a onedrive link</li>
            </ul>
            </p>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  name: "packages",
  metaInfo: {
    title: "Jeanna Chambers",
    titleTemplate: "%s | Packages",
  },
};
</script>

<style lang="scss">
.header-plate {
  padding: 1rem 1.5rem;
  background-color: $color-white;
}

.popup-packages {
  top: 0;
  left: 0;
  background-color: rgba($color-black, 0.8);
  position: fixed;
  z-index: 10000;
  opacity: 1;
  transition: all 0.3s;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch; //we'll see
  backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @supports (-webkit-backdrop-filter: blur(10px)) or
    (backdrop-filter: blur(10px)) {
    background-color: rgba($color-black, 0.3);
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  &--content {
    min-width: 100vw;
    max-height: 100vh;
    background-color: $color-primary;
    top: 0;
    left: 0;
    padding: 2rem;
    overflow-y: scroll;
  }

  &__close {
    &:link,
    &:visited {
      position: fixed;
      top: 2.5rem;
      right: 2.5rem;
      font-size: 6rem;
      text-decoration: none;
      display: inline-block;
      transition: all 0.2s;
      line-height: 1;
      z-index: 11001;
      color: $color-black;
    }

    &:hover {
      color: $color-grey-light-1;
    }
  }
}

.package__content {
  display: flex;
  flex-direction: column;
  padding: 3rem;
  min-height: 100vh;
  overflow-y: scroll;
  margin: auto;
  max-width: 95%;
  justify-content: space-around;
  // flex-flow: row wrap;

  @include respond(tab-port) {
    align-content: flex-start;
    padding: 0 1rem;
    max-width: 95%;
  }

  &--image {
    background-size: contain;
    height: 0;
    padding-top: calc(850 / 1277 * 100%);
    color: $color-black;
    background-color: $color-white;
    background-image: url("../assets/IMAGES/package-img.jpg");
    background-position: center;
    background-repeat: no-repeat;
    font-size: 1.6rem;
    width: 100%;
    margin: auto;
  }

  &--examples {
    background-color: $color-grey-light-1;
    padding-left: 1rem;
    border-radius: 2rem;
  }

  &--duration {
    color: $color-primary;
    padding: 1rem 1rem;
  }

  &--price {
    color: $color-primary-dark;
    font-size: 2rem;
    text-align: right;
  }

  &--photo {
    box-shadow: 0 1.5rem 4rem rgba($color-black, 0.5);
    border-radius: 2px;
    transition: all 0.2s;
    padding: 1rem;
    flex: 1 2 50%;
    max-width: 50%;
    align-self: flex-start;

    img {
      display: block;
      width: 50%;
      height: auto;
      margin: auto;
    }

    @include respond(tab-port) {
      box-shadow: 0 1.5 3rem rgba($color-black, 0.2);
      // padding: 0 1rem;
      // max-width: 100%;
    }

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 2.5rem 4rem rgba($color-black, 0.5);
      z-index: 20;
    }
  }

  &:hover &__photo:not(:hover) {
    transform: scale(0.95);
  }
}

.package-heading {
  font-size: 2.5rem;
}
</style>
